import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ClaimSubmissionReviewAttributes } from '../../claim-submission.model';

@Component({
  selector: 'lib-claim-line-info-review',
  templateUrl: './claim-line-info-review.component.html',
  styleUrls: ['./claim-line-info-review.component.scss'],
})
export class ClaimLineInfoReviewComponent {
  @Input() claimInfoConfig: ClaimSubmissionReviewAttributes;
  @Input() claimLineInfoContext: { fg_array: UntypedFormGroup[] };
  @Input() isEditable = true;
  @Output() editIconClickedValue: EventEmitter<void> = new EventEmitter<void>();

  editIconClicked() {
    this.editIconClickedValue.emit();
  }
}
